export default "__VITE_ASSET__BqC7bNhU__"